var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C3.79086 2 2 3.79086 2 6V16C2 18.2091 3.79086 20 6 20H16C18.2091 20 20 18.2091 20 16V6C20 3.79086 18.2091 2 16 2H6ZM0 6C0 2.68629 2.68629 0 6 0H16C19.3137 0 22 2.68629 22 6V16C22 19.3137 19.3137 22 16 22H6C2.68629 22 0 19.3137 0 16V6Z",
    fill: "#12B7A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4833 7.98949C10.8591 7.89693 10.2217 8.00354 9.66157 8.29417C9.10147 8.58479 8.64727 9.04463 8.36357 9.60827C8.07988 10.1719 7.98113 10.8107 8.08138 11.4336C8.18163 12.0566 8.47577 12.6322 8.92196 13.0784C9.36815 13.5245 9.94367 13.8187 10.5667 13.9189C11.1897 14.0192 11.8284 13.9204 12.392 13.6367C12.9557 13.353 13.4155 12.8988 13.7061 12.3387C13.9968 11.7786 14.1034 11.1412 14.0108 10.517C13.9164 9.88029 13.6197 9.29085 13.1646 8.83572C12.7095 8.38058 12.12 8.0839 11.4833 7.98949ZM8.74043 6.51892C9.67393 6.03455 10.7364 5.85685 11.7767 6.01112C12.8379 6.16847 13.8203 6.66295 14.5788 7.4215C15.3374 8.18006 15.8318 9.16247 15.9892 10.2236C16.1435 11.2639 15.9658 12.3264 15.4814 13.2599C14.997 14.1934 14.2306 14.9504 13.2912 15.4232C12.3518 15.896 11.2873 16.0606 10.2489 15.8935C9.2106 15.7265 8.2514 15.2362 7.50775 14.4926C6.76409 13.7489 6.27386 12.7897 6.10678 11.7514C5.9397 10.7131 6.10428 9.64849 6.5771 8.70909C7.04993 7.76969 7.80693 7.00329 8.74043 6.51892Z",
    fill: "#12B7A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7b253d1eaf8074e1ad91bf034376d9e9.svg";
export { ForwardRef as ReactComponent };